import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency } from 'shared/utils/currency-format.util';

@Pipe({
  name: 'currencyFormat',
  standalone: true,
})
export class CurrencyFormatPipe implements PipeTransform {
  transform(
    value: number | string | null | undefined,
    decimals: number = 2
  ): string {
    return formatCurrency(value, decimals);
  }
}
